import * as React from 'react';
import { BasicPagination } from 'components/Pagination';
import { PaginatorProps } from '../types';
import { FlexBox } from '@kis-technologies/kis-ui';

export const Paginator = <T extends object>(props: PaginatorProps<T>) => {
  const {
    items,
    itemsPerPage,
    page,
    onPageChange,
    children,
    paginationComponent: PaginationComponent = BasicPagination
  } = props;

  const pages = Math.ceil(items.length / itemsPerPage);
  const itemsSubsetStart = (page - 1) * itemsPerPage;
  const itemsSubsetEnd = itemsSubsetStart + itemsPerPage;
  const itemsSubset = items.slice(itemsSubsetStart, itemsSubsetEnd);

  const handlePageChange = (pageNum: number) => {
    onPageChange(pageNum);
  };

  return (
    <FlexBox direction="column" justify="between" flexOverride="1">
      {children({
        pages,
        page,
        items: itemsSubset,
        changePage: handlePageChange
      })}

      {pages > 1 && <PaginationComponent pages={pages} page={page} onPageChange={handlePageChange} />}
    </FlexBox>
  );
};
